import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DefaultLayout from '../layouts/default/Default.layout';
import PdfAnnotator from '../components/PdfAnnotator/PdfAnnotator';
import { PdfDocument } from '../../sdk/@types/Acertei';
import PdfDocumentService from '../../sdk/services/PdfDocumentService';
import AccessDenied from '../components/AccessDenied/AccessDenied';
import { readApiError, type ApiError } from '../../sdk/errors/apiError';

const { Option } = Select;

export default function PdfAnnotatorPage() {
  const [searchParams] = useSearchParams();
  const docIdParam = searchParams.get('docId');

  const [pdfDocs, setPdfDocs] = useState<PdfDocument[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [denial, setDenial] = useState<ApiError | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    PdfDocumentService.list()
      .then(data => {
        const docs = data ?? [];
        setPdfDocs(docs);
        if (docIdParam) {
          const idx = docs.findIndex(d => d.ID === docIdParam);
          if (idx !== -1) setSelectedIndex(idx);
        }
      })
      // Sem isto, um 403 caía no seletor como "Nenhum documento cadastrado" —
      // a tela dizia que o banco estava vazio quando o problema era o acesso.
      .catch(error => {
        const apiError = readApiError(error);
        if (apiError.kind) setDenial(apiError);
        setPdfDocs([]);
      });
  }, []);

  const selectedDoc: PdfDocument | null = selectedIndex !== null ? (pdfDocs[selectedIndex] ?? null) : null;

  if (denial) {
    return (
      <DefaultLayout>
        <div className="p-6">
          <AccessDenied
            kind={denial.kind!}
            detail={denial.raw}
            variant="panel"
            onNavigate={navigate}
          />
        </div>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout>
      <div className="flex flex-col" style={{ height: 'calc(100vh - 80px)' }}>
        <div className="flex items-center gap-4 px-4 py-2 bg-[#0f1a10] border-b border-[#1a2e1c] flex-shrink-0">
          <span className="text-sm text-[#6b8f6e]">Documento:</span>
          <Select
            placeholder="Selecionar documento PDF..."
            value={selectedIndex ?? undefined}
            onChange={(idx: number) => setSelectedIndex(idx)}
            style={{ width: 320 }}
            size="small"
            notFoundContent="Nenhum documento cadastrado"
          >
            {pdfDocs.map((doc, i) => (
              <Option key={i} value={i}>
                {doc.Title}
              </Option>
            ))}
          </Select>
        </div>

        <div className="flex-1 overflow-hidden">
          {selectedDoc ? (
            <PdfAnnotator
              key={selectedIndex ?? 0}
              pdfDocId={selectedDoc.ID}
              fileKey={selectedDoc.FileKey}
            />
          ) : (
            <div className="flex items-center justify-center h-full text-[#6b8f6e]">
              Selecione um documento para começar
            </div>
          )}
        </div>
      </div>
    </DefaultLayout>
  );
}
